/**
 * Bootstrap helper functions for component initialization
 */

/**
 * Initialize all Bootstrap components on the page
 */
export function initializeBootstrapComponents() {
  if (typeof window !== 'undefined' && window.bootstrap) {
    // Initialize dropdowns
    const dropdownTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="dropdown"]'));
    dropdownTriggerList.forEach((dropdownTriggerEl) => {
      if (!window.bootstrap.Dropdown.getInstance(dropdownTriggerEl as Element)) {
        new window.bootstrap.Dropdown(dropdownTriggerEl as Element);
      }
    });

    // Initialize tooltips
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      if (!window.bootstrap.Tooltip.getInstance(tooltipTriggerEl as Element)) {
        new window.bootstrap.Tooltip(tooltipTriggerEl as Element);
      }
    });

    // Initialize popovers
    const popoverTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.forEach((popoverTriggerEl) => {
      if (!window.bootstrap.Popover.getInstance(popoverTriggerEl as Element)) {
        new window.bootstrap.Popover(popoverTriggerEl as Element);
      }
    });

    // Initialize modals
    const modalTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="modal"]'));
    modalTriggerList.forEach((modalTriggerEl) => {
      if (!window.bootstrap.Modal.getInstance(modalTriggerEl as Element)) {
        new window.bootstrap.Modal(modalTriggerEl as Element);
      }
    });

    // Initialize collapses
    const collapseTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="collapse"]'));
    collapseTriggerList.forEach((collapseTriggerEl) => {
      if (!window.bootstrap.Collapse.getInstance(collapseTriggerEl as Element)) {
        new window.bootstrap.Collapse(collapseTriggerEl as Element);
      }
    });

    // Initialize tabs
    const tabTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tab"]'));
    tabTriggerList.forEach((tabTriggerEl) => {
      if (!window.bootstrap.Tab.getInstance(tabTriggerEl as Element)) {
        new window.bootstrap.Tab(tabTriggerEl as Element);
      }
    });
  }
}

/**
 * Initialize specific Bootstrap component type
 * @param selector - CSS selector to find elements
 * @param type - Component type ('Dropdown', 'Modal', etc.)
 */
export function initializeSpecificComponent(selector: string, type: string) {
  if (typeof window !== 'undefined' && window.bootstrap && window.bootstrap[type]) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      if (!window.bootstrap[type].getInstance(el)) {
        new window.bootstrap[type](el);
      }
    });
  }
}

/**
 * Close the mobile navigation menu
 */
export function closeMobileNavigation() {
  if (window.innerWidth < 992) {
    const offcanvasEl = document.getElementById('mainbar');
    if (offcanvasEl && offcanvasEl.classList.contains('show')) {
      // Method 1: Using Bootstrap instance (same as before)
      if (typeof window.bootstrap !== 'undefined' && window.bootstrap.Offcanvas) {
        const offcanvasInstance = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
        if (offcanvasInstance) {
          offcanvasInstance.hide();
          return; // Exit if this succeeds
        }
      }
      
      // Method 2: Using close button click simulation (backup method)
      const closeButton = offcanvasEl.querySelector('[data-bs-dismiss="offcanvas"]');
      if (closeButton) {
        (closeButton as HTMLElement).click();
        return; // Exit if this succeeds
      }
      
      // Method 3: Direct DOM manipulation (last resort)
      offcanvasEl.classList.remove('show');
      document.body.classList.remove('overflow-hidden');
      const backdrop = document.querySelector('.offcanvas-backdrop');
      if (backdrop) {
        document.body.removeChild(backdrop);
      }
    }
  }
} 